import React from 'react';
import PropTypes from 'prop-types';
import { Text, Input, Button } from '../../Atoms';
import SendDocumentErrors from './SendDocumentErrors';

const MedicineStep2 = ({
  type,
  category,
  description,
  onChange,
  onSubmit,
  sendDocumentErrors
}) => (
  <div>
    {/* category */}
    <Text
      text={type.name + ' - ' + category}
      type="h8"
      className="header-description-document-step2"
    />

    {/* Textarea message */}
    <Input
      className="input-decription-document input-description-medicine"
      onChange={(e) => onChange(e)}
      value={description}
      as="textarea"
      placeholder="Laissez-nous un message qui décrit votre besoin (facultatif)"
    />

    <div className="container-description-spvie-medicine">
      <Text
        text="Vous pouvez également nous transmettre ces documents par voie postale à l'adresse ci-dessous :"
        className={'description-condition-send-document  doc-mar-bot'}
      />
      <div className="description-spvie-medicine">
        <Text
          text="SPVIE Remboursements"
          className={'description-condition-send-document  doc-mar-bot'}
        />
        <Text
          text="CGRM TSA 91005"
          className={'description-condition-send-document doc-mar-bot'}
        />
        <Text
          text="59952 Dunkerque"
          className={'description-condition-send-document doc-mar-bot'}
        />
      </div>
    </div>

    <SendDocumentErrors errors={sendDocumentErrors} />
    <div className="container-btn-send-doc">
      <Button
        text="Envoyer"
        className="btn-send-doc btn-send-doc-medicine"
        onClick={() => onSubmit()}
        resetHover={true}
      />
    </div>
  </div>
);

// PropTypes validation for component props
MedicineStep2.propTypes = {
  type: PropTypes.shape({
    name: PropTypes.string.isRequired // type object must have a name string
  }).isRequired,
  category: PropTypes.string.isRequired, // category must be a string
  description: PropTypes.string.isRequired, // description must be a string
  onChange: PropTypes.func.isRequired, // onChange must be a function
  onSubmit: PropTypes.func.isRequired, // onSubmit must be a function
  sendDocumentErrors: PropTypes.arrayOf(PropTypes.string) // messages d'erreur de l'API
};

export default MedicineStep2;
